<template>
  <div class="tw-flex tw-flex-col tw-gap-2">
    <div class="tw-flex tw-items-center tw-justify-between tw-gap-x-4 tw-gap-y-1 tw-flex-wrap">
      <div class="tw-flex tw-items-baseline tw-gap-x-3 tw-flex-wrap">
        <h2 class="tw-text-lg tw-font-bold tw-text-gray-800 tw-m-0">{{ addressLabel }}</h2>
        <span class="tw-text-sm tw-text-gray-600">
          {{ meterDetail.zip_code }} {{ meterDetail.zip_code_ext }}<span v-if="meterDetail.city"> {{ meterDetail.city }}</span>
        </span>
        <span
          v-if="kind === 'cvz'"
          class="tw-text-xs tw-font-medium tw-px-2 tw-py-0.5 tw-rounded tw-bg-amber-100 tw-text-amber-800"
          title="Collectieve installatie: de meters staan vaak op aparte, genummerde adressen (CVZ1, CVZ2, ...)"
        >CVZ</span>
      </div>
      <div class="tw-text-xs tw-text-gray-500 tw-flex tw-items-center tw-gap-1.5 tw-flex-wrap">
        <!-- no woco name: the project names start with it -->
        <template v-if="projectNames.length">
          <span v-if="projectNames.length > 1" class="tw-text-gray-400">{{ projectNames.length }} projecten:</span>
          <span
            v-for="project in projectNames"
            :key="project"
            :class="projectNames.length > 1 ? 'tw-bg-gray-100 tw-rounded tw-px-1.5 tw-py-0.5 tw-text-gray-700' : ''"
          >{{ project }}</span>
        </template>
      </div>
    </div>

    <div v-for="(msg, i) in warnings" :key="i" class="tw-text-xs tw-text-amber-700 tw-bg-amber-50 tw-rounded tw-p-2">
      {{ msg }}
    </div>
  </div>
</template>

<script setup>
// The top of the overview section: the address (with CVZ badge), its projects, and warnings about it
import { computed } from 'vue'
import { addressLabelNL } from './formatters'

const props = defineProps({
  meterDetail: { type: Object, required: true },
  // from useAddressDevices
  kind: { type: String, default: 'regular' },
  warnings: { type: Array, default: () => [] },
  // the ERP projects of the address (useAddressLocation); more than one since multi-project addresses
  projects: { type: Array, default: () => [] },
})

const addressLabel = computed(() => addressLabelNL(props.meterDetail, props.kind))

// ERP projects when the ERP knows the address, else the project energize has
const projectNames = computed(() =>
  props.projects.length ? props.projects : [props.meterDetail.project_name].filter(Boolean)
)

</script>
